// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".attribute-custom[data-v-79b6f5c0]{margin-bottom:5px;font-size:12px}.custom-control-label[data-v-79b6f5c0]{color:#6e7279}.custom-control-input:checked+.custom-control-label[data-v-79b6f5c0]{color:#2d303a}.custom-checkbox .custom-control-input:checked~.custom-control-label[data-v-79b6f5c0]:after,.custom-control-label[data-v-79b6f5c0]:before{top:1px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
